export const DATADOG_EVENTS = {
  EXPERIMENT_BUCKETING_FAILED: 'experiment-bucketing-failed',
  MARKETING: {
    /* onMount */
    PAGE_RENDERED: `page-rendered`,

    /* click events */
    CLICKS_ALLCREDITTYPES_CTA: 'clicks-all-credit-types-cta',
    CLICKS_CHOOSECARVANA_CTA: 'clicks-choose-carvana-cta',
    CLICKS_FAQ: `clicks-faq`,
    CLICKS_HERO_CTA: `clicks-hero-cta`,
    CLICKS_UNLOCKREALPAYMENTS_CTA: `clicks-unlock-real-payments-cta`,
    CLICKS_VALUEPROP_CTA: `clicks-value-prop-cta`,
    CLICKS_WHYCARVANA_CTA: `clicks-why-carvana-cta`
  },
  PREQUALIFIED: {
    /* onMount */
    PAGE_RENDERED: `page-rendered`,

    /* click & interaction events */
    CLICKS_HERO_CTA: `clicks-hero-cta`,
    // NOTE(2024/12): `taf-core-finx-active-redesign-p1` experiment only
    CLICKS_ADD_COSIGNER_HERO: `clicks-add-cosigner-hero`,
    CLICKS_ADD_COSIGNER: `clicks-add-cosigner`,
    CLICKS_EDIT_COSIGNER: `clicks-edit-cosigner`,
    TOGGLES_COSIGNER: `clicks-toggle-cosigner`,
    CLICKS_ADD_TRADEIN: `clicks-add-tradein`,
    CLICKS_VIEW_TRADEIN_DETAILS: `clicks-view-tradein-details`,
    TOGGLES_TRADEIN: `toggles-tradein`,
    CLICKS_BODYSTYLE: `clicks-bodystyle`,
    SETS_SHOPBYPAYMENT: `sets-shopbypayment-dropdown`,
    CLICKS_SHOPBYPAYMENT_CTA: `clicks-shopbypayment-cta`,
    CLICKS_SHOPBYCASHDOWN: `clicks-shopbycashdown`,
    CLICKS_FAQ: `clicks-faq`,
    TOGGLE_COMPLETE: `toggle-complete`,
    // This Error Render is a boundary within Prequal page
    // The "limited" Prequal Hero will render, but this error boundary will catch any errors
    // for all other Prequal section components
    PAGE_ERROR: `prequalified-page-error`,
    PAGE_ERROR_CLICKED_RESET: `prequalified-page-error-clicked-reset`,
    PAGE_ERROR_CLICKED_HOME: `prequalified-page-error-clicked-home`
  },
  API: {
    /* API events */
    TERMS_UPDATED: `terms-updated`,
    REFRESH_TERMS_API_CALL: `refresh-terms-api-call`,
    REFRESH_TERMS_API_NOT_OK: `refresh-terms-api-not-ok`,
    REFRESH_TERMS_API_ERROR: `refresh-terms-api-error`,
    REFRESH_TERMS_INVALID_RESPONSE: `refresh-terms-invalid-response`,
    /* Call site data validation events */
    CALLER_MISSING_DATA: `caller-missing-data`,
    CREDIT_APPLICATION_UPDATED: `credit-application-updated`,
    TOGGLE_COAPPLICANT_API_CALL: `toggle-coapplicant-api-call`,
    TOGGLE_COAPPLICANT_API_NOT_OK: `toggle-coapplicant-api-not-ok`,
    TOGGLE_COAPPLICANT_API_ERROR: `toggle-coapplicant-api-error`,
    TOGGLE_TRADEIN_API_CALL: `toggle-tradein-api-call`,
    TOGGLE_TRADEIN_API_NOT_OK: `toggle-tradein-api-not-ok`,
    TOGGLE_TRADEIN_API_ERROR: `toggle-tradein-api-error`,
    /* financing-rsc: initial data-fetch and post-softpull refresh failures */
    CREDIT_APPLICATION_FETCH_ERROR: `credit-application-fetch-error`,
    PRICING_AGGREGATES_FETCH_ERROR: `pricing-aggregates-fetch-error`,
    REFRESH_AFTER_SOFTPULL_API_ERROR: `refresh-after-softpull-api-error`
  },
  PAGE_ERROR: {
    ERROR_PAGE_VIEWED: `error-page-viewed`,
    CLICKED_PAGE_RESET: `clicks-error-page-reset`,
    CLICKED_GO_HOME: `clicks-error-page-go-home`
  },
  TIMINGS: {
    PREQUALIFIED_RESOLVED: 'prequalified_resolved'
  }
};
